import { render, staticRenderFns } from "./PeripheralDetailsCard.vue?vue&type=template&id=acb7754e&"
import script from "./PeripheralDetailsCard.vue?vue&type=script&lang=ts&"
export * from "./PeripheralDetailsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports